<template>
    <div class="boat-card bboat-bg pb-4 w-100">
        <aspect-ratio ratio-width="16" ratio-height="9">
            <img v-if="boat.featuredImageURL"
                 :src="boat.featuredImageURL"
                 alt="View Boat Details"
                 v-on:click="viewBoatDetails" />
            <default-image v-else-if="boat.model"
                           :model="boat.model"
                           alt-text="View Boat Details"
                           :width="230"
                           @click="viewBoatDetails" />
        </aspect-ratio>

        <div class="boat-model pt-4 px-4">{{ boat.modelYear }} {{ formatModel(boat.model) }}</div>
        <div class="boat-price px-4" v-if="boat?.price > 0">
            Starting at ${{ formatPrice(boat?.price) }} USD
        </div>
        <div class="boat-price px-4" v-if="boat.price == null || boat.price == 0">
            Please call for pricing.
        </div>
        <custom-check-box :left="'left'"
                  :id="'compare_' + boat.boatID"
                  v-model="isCompareChecked"
                  checkBoxLabel="Compare Boat"
                  @update:modelValue="onCompareCheckboxChange"
                  :disabled="checkboxDisabled"
                  v-if="showCompare === true" />
        <div class="px-4">
            <custom-button class="btn-main"
                    :data="boat.boatID"
                    v-on:btnClicked="viewBoatDetails()">
                View Boat
            </custom-button>
        </div>
    </div>
</template>
<script>
    import CustomButton from "./CustomButton";
    import CustomCheckBox from "./CustomCheckBox.vue";
    import DefaultImage from "./DefaultImage.vue";
    import AspectRatio from "./AspectRatio.vue";
    import StringUtils from "../../helpers/StringUtils";

    export default {
        name: "BoatCard",
        props: [
            "boat",
            "showCompare",
            "checkboxDisabled",
            "isChecked"
        ],
        data() {
            return {
                isCompareChecked: this.isChecked
            };
        },
        watch: {
            isChecked(newValue) {
                this.isCompareChecked = newValue;
            }
        },
        components: {
            CustomButton,
            CustomCheckBox,
            DefaultImage,
            AspectRatio,
        },
        mounted() {

        },
        methods: {
            viewBoatDetails() {
                window.location = "/boat/details/" + this.boat.boatID;
            },
            formatModel(model) {
                return StringUtils.formatModel(model);
            },
            formatPrice(value) {
                return StringUtils.formatPrice(value);
            },
            onCompareCheckboxChange(newValue) {
                if (newValue == true) {
                    this.$emit("onCompareCheck", this.boat.boatID);
                }
                else {
                    this.$emit("onCompareUncheck", this.boat.boatID);
                }
            }
        },
    };
</script>
